export default "__VITE_ASSET__CNMFWcNF__"